import { SupportedEnv, SupportedEnvironments } from './environments'

export enum Wallet {
  METAMASK = 'METAMASK',
  WALLET_CONNECT = 'WALLET_CONNECT',
}

export interface WalletInfo {
  wallet: Wallet
  name: string
  description: string
  mobile?: true
  mobileOnly?: true
}

export const SUPPORTED_WALLETS: { [key in Wallet]: WalletInfo } = {
  METAMASK: {
    wallet: Wallet.METAMASK,
    name: 'MetaMask',
    description: 'Easy-to-use browser extension.',
  },
  WALLET_CONNECT: {
    wallet: Wallet.WALLET_CONNECT,
    name: 'WalletConnect',
    description: 'Connect to Trust Wallet, Rainbow Wallet and more...',
    mobile: true,
  },
}

const getWithdrawalAddressForEnv = (env: SupportedEnvironments) => {
  switch (env) {
    case SupportedEnv.BETA:
      return '0xc12f7a41f5ec505e468c786097cd79df3e38c81b'
    case SupportedEnv.STAGE:
      return '0xF3144cC1cd94682483d2D3241977DDf08AcC6496'
    default:
      throw new Error('Unsupported Environment')
  }
}

export const WITHDRAWAL_ADDRESS = getWithdrawalAddressForEnv(
  process.env.NEXT_PUBLIC_NSFW_ENV as SupportedEnvironments
)
